class StatementsPlanFilter {
  constructor(options = {}) {
    this.element = options.element;
    this.opener = this.element.querySelector('.org-statements__plan-filter-opener');
    this.modal = this.element.querySelector('.org-statements__plan-filter-modal');
    this.closeButton = this.element.querySelector('.org-statements__plan-filter-close');
    this.confirmButton = this.element.querySelector('.org-statements__plan-filter-confirm');
    this.onKeydown = this.onKeydown.bind(this);
  }

  init() {
    if (!this.opener || !this.modal) {
      return;
    }

    this.opener.addEventListener('click', () => this.open());

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', this.onKeydown);
  }

  open() {
    this.modal.classList.add('is-open');
    this.modal.setAttribute('role', 'dialog');
    this.modal.setAttribute('aria-modal', 'true');
    this.opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');

    if (this.closeButton) {
      this.closeButton.focus();
    }
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.removeAttribute('role');
    this.modal.removeAttribute('aria-modal');
    this.opener.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
    this.opener.focus();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
      this.close();
    }
  }
}

export default StatementsPlanFilter;
